class Utils {
  /**
   * Creates a json object with the fields given in the model.
   * This is used to create a replica of database object so that
   * we make changes to model and that model is converted to json
   * then in turn its saved
   *
   * @param {*} model
   * @returns {Object} json
   * @memberof Utils
   */
  mapDatabaseFields(model) {
    var keys = Object.keys(model);
    var json = {};
    keys.forEach(function(value) {
      //console.log(value);
      //console.log(model[value]);
      //console.log(key);
      json[value] = model[value];
    });
    return json;
  }

  /**
   * Get today's date in specific format like 29-04-2019
   *
   * @returns {string} dateString
   * @memberof Utils
   */
  getDate() {
    var now = new Date();
    var day = ("0" + now.getDate()).slice(-2);
    var month = ("0" + (now.getMonth() + 1)).slice(-2);
    var today = day + "-" + month + "-" + now.getFullYear();

    return today;
  }

  /**
   * Get percentage based on number of days and present days
   *
   * @param {*} present
   * @param {*} days
   * @param {*} status
   * @returns {Number} percent
   * @memberof Utils
   */
  getAttendancePercentage(present, days, status) {
    var percent = 0;
    //#TODO change strings to enums
    if (status == "present") {
      percent = ((present + 1) / (days + 1)) * 100;
    } else if (status == "absent") {
      percent = (present / (days + 1)) * 100;
    }

    return percent;
  }

  /**
   * Get dropout status of a student based on last 2 days attendance.
   * For now the understanding is that if student is absent for 3
   * consequitive days then he should be marked as dropout
   * So here we calculate last 2 days attendance and see if they are
   * absent and then based on the status which is "present" or "absent"
   * then if the status is absent then we can count as current day
   * attendance as the third day ones and then we can conculude its
   * a dropout case
   *
   * @param {Number} days
   * @param {Number} dropoutThreshold
   * @param {Array} attendanceKeys
   * @param {Array} attendance
   * @param {String} status
   * @returns {Boolean} isDropout
   * @memberof Utils
   */
  getDropoutStatus(days, dropoutThreshold, attendanceKeys, attendance, status) {
    var dropoutCounter = 0;
    var isDropout = false;
    if (days >= dropoutThreshold) {
      for (var i = days - dropoutThreshold; i < days; i++) {
        var key = attendanceKeys[i];
        var value = attendance[key];
        if (!value) {
          dropoutCounter++;
          //#TODO change strings to enums
          if (dropoutCounter == dropoutThreshold && status == "absent") {
            isDropout = true;
          }
        }
      }
    }

    return isDropout;
  }

  /**
   * Get number of days present from the whole attendance list
   *
   * @param {Number} days
   * @param {Array} attendanceKeys
   * @param {Array} attendance
   * @returns {Number} daysPresent
   * @memberof Utils
   */
  getDaysPresent(days, attendanceKeys, attendance) {
    var present = 0;
    for (var i = 0; i < days; i++) {
      var key = attendanceKeys[i];
      var value = attendance[key];
      if (value) {
        present++;
      }
    }

    return present;
  }

  /**
   * Remove a specific element in array and give a new array
   * original_array = [2,3,4]
   *
   * usage :
   * removeArrayElement(original_array, 3);
   *
   * output :
   * [2,4]
   *
   * @param {Array} arr
   * @param {String} value
   * @returns {Array} newArray
   * @memberof Utils
   */
  removeArrayElement(arr, value) {
    return arr.filter(function(ele) {
      return ele != value;
    });
  }

  /**
   * Convert first letter of a sentance to upper
   *
   * @param {String} s
   * @returns {String} updatedString
   * @memberof Utils
   */
  UpperCasefirst(s) {
    if (typeof s !== "string") return "";
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  /**
   * Get values from localstorage
   *
   * @param {String} item
   * @returns {Object} localStorageItemObject
   * @memberof Utils
   */
  getFromLocalStorage(item) {
    var state = localStorage.getItem(item);
    var payload = JSON.parse(state);
    return payload;
  }

  /**
   * Get session from localstorage where state info is saved
   *
   * Used in saving data like state which inturn used in router
   * Its used because when page is refreshed store is not saving
   * data and its lost so we need to get the previous state of
   * store into localstorage and then save it when store updates
   *
   * @param {Object} router
   * @returns {Boolean} isUserExistsInLocalStorage
   * @memberof Utils
   */
  loadSessionFromLocalStorage(router) {
    if (localStorage.getItem("state")) {
      var payload = this.getFromLocalStorage("state");
      router.app.$store.commit("_login_details", payload);
      return true;
    } else return false;
  }

  /**
   * Get logged in user info from store and if not available
   * get it from localstorage
   *
   * @param {Object} router
   * @returns {Boolean} isUserExistsInLocalStorage
   * @memberof Utils
   */
  getCurrentUser(router, store) {
    let user =
      store.getters.get_login || this.loadSessionFromLocalStorage(router);
    return user;
  }

  /**
   * Gets Item from List of items based on the Id given
   *
   * @param {*} list
   * @param {*} Id
   * @returns {*} Item
   * @memberof Utils
   */
  getItemFromListWithId(list, Id) {
    var el;
    list.forEach(element => {
      if (element.Id == Id) {
        el = element;
      }
    });

    return el;
  }

  mapIdsWithObjects(ids, objects) {
    var itemObjects = [];
    objects.forEach(object => {
      var objectId = object.Id;
      if (ids != undefined && ids != "") {
        ids.forEach(id => {
          if (id == objectId) itemObjects.push(object);
        });
      }
    });
    Object.assign(ids, itemObjects);
  }

  getObjectsOfIds(ids, objects) {
    var itemObjects = [];
    objects.forEach(object => {
      var objectId = object.Id;
      if (ids != undefined && ids != "") {
        ids.forEach(id => {
          if (id == objectId) itemObjects.push(object);
        });
      }
    });
    return itemObjects;
  }

  mergeObjects(first, second) {
    var mergedObjects = [];
    first.forEach(firstElement => {
      second.forEach(secondElement => {
        if (firstElement.Id == secondElement.Id) {
          var mergedObject = {};
          Object.assign(mergedObject, firstElement);
          Object.assign(mergedObject, secondElement);
          mergedObjects.push(mergedObject);
        }
      });
    });
    return mergedObjects;
  }
}

export default new Utils();
